// Centralized application configuration
import config from '../configs/config';

// Generic HTTP request wrapper for SyncUp Platform APIs
import syncUpPlatformRequest from '../repositories/syncupPlatformRequest';

// Repository layer responsible for communicating with
// SyncUp Platform feature flag endpoints
const featureFlagsRepository = {
  /**
   * Fetches feature flags for a specific SyncUp application
   *
   * @param {Object} params
   * @param {string} params.syncUpAppName - SyncUp application name sent as request header
   * @param {boolean} [params.responseStatus=false] - Whether to return full response status
   * @returns {Promise<Object|Array>} API response containing feature flags
   */
  getFeatureFlags: async ({ syncUpAppName, responseStatus = false }) => {
    // Destructure required API configuration values
    const {
      resources,
      basePath,
      httpMethods,
      headers
    } = config.apiSettings.syncUpPlatform;

    // Execute HTTP GET request to fetch feature flags
    return await syncUpPlatformRequest({
      // API endpoint for feature flags
      urlSuffix: resources.featureFlags,

      // Admin drive base path
      basePath: basePath.adminDrive,

      // HTTP method for retrieval
      httpMethod: httpMethods.GET,

      // Flag to include response status if needed
      responseStatus: responseStatus,

      // Required request headers
      headers: {
        // Pass SyncUp application name as custom header
        [headers.SyncUpProduct.key]: syncUpAppName
      }
    });
  }
};

export default featureFlagsRepository;
